import React from "react";

const WorkingArea = () => {
  return (
    <>
      <section className="welcome-area" style={{ marginTop: "-80px" }}>
        <div className="container clearfix">
          <div className="sec-title">
            <h2>
              <span>PROJECT </span>EXECUTION
            </h2>
            <span className="decor" />
            <section className="working-area">
              <div className="container">
                {/* <div className="sec-title text-center">
                  <h2>Turnkey Fit Out</h2>
                  <span className="decor" />
                </div> */}
                <section className="design-desc-area" style={{ marginTop: "-150px" }}>
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="tab-content">
                          <div className="tab-pane fade in active" id="commer">
                            <div className="inner-content">
                              <div className="row">
                                <div className="col-md-6">
                                  <div
                                    id="design-single-carousel-0"
                                    className="carousel slide"
                                    data-ride="carousel"
                                  >
                                    <ol className="carousel-indicators">
                                      <li
                                        data-target="#design-single-carousel-0"
                                        data-slide-to={0}
                                        className="active-1"
                                      />
                                      <li
                                        data-target="#design-single-carousel-0"
                                        data-slide-to={1}
                                      />
                                      <li
                                        data-target="#design-single-carousel-0"
                                        data-slide-to={2}
                                      />
                                    </ol>
                                    <div className="carousel-inner" role="listbox">
                                      <div className="item active">
                                        <div className="single-item">
                                          <div className="img-holder">
                                            <img
                                              src="images/services/service-single/design-1.jpg"
                                              alt="Awesome Image"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="item">
                                        <div className="single-item">
                                          <div className="img-holder">
                                            <img
                                              src="images/services/service-single/design-2.jpg"
                                              alt="Awesome Image"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="item">
                                        <div className="single-item">
                                          <div className="img-holder">
                                            <img
                                              src="images/services/service-single/design-3.jpg"
                                              alt="Awesome Image"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="text-holder">
                                    <div className="sec-title-two" style={{ marginTop: "-15px" }}>
                                      <h3><b>Turnkey Fit Out</b></h3>
                                    </div>
                                    <div className="text bold">
                                      <p>
                                        Space Design Studio offers a fully comprehensive service for both corporate and domestic clients from start to finish. Our complete turnkey solution and build service ensure speed, efficiency and a seamless co-ordination between each element of the process. Our Services range from design advice and conceptualization to full architectural design and site construction facilities, including planning permission submissions and building control recommendations for an array of sections such as municipality requirements and Civil Defense.
                                      </p>
                                      <p>Due to our extensive knowledge coupled with several partnerships with some of the India’s top suppliers is guaranteed to give you a result where attention to detail is paramount.</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>



              </div>
            </section>
          </div>
        </div>
      </section>

      <section className="section-big main-color" style={{ marginTop: "-80px" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <ul className="i-list medium">
                <li className="i-list-item">
                  <div className="icon">
                    <i className="fa fa-desktop" />{" "}
                  </div>
                  <div className="icon-content">
                    <h3 className="title">Site Supervision</h3>
                    <p className="sub-title">
                      <ul className="bold">
                        <li style={{textAlign:""}}><>It is essential that the quality of the building match the bespoke service that we provide.This means that our site supervisor closely monitors the construction work on a frequent basis. We work with only the best contractors and suppliers to ensure construction is on schedule and of superior standard.</></li>
                        
                      </ul>
                    </p>
                  </div>
                  <div className="iconlist-timeline" />
                </li>
                </ul>
            </div>
            <div className="col-md-4">
              <ul className="i-list medium">
                <li className="i-list-item">
                  <div className="icon">
                    {" "}
                    <i className="fa fa-diamond" />{" "}
                  </div>
                  <div className="icon-content">
                    <h3 className="title">Quality of Finish </h3>
                  </div>

                  <div className="icon-content">
                   
                    <p>
                      <ul className="bold">
                        <li>
                          Our extensive knowledge of interiors coupled with several partnerships with some of the Delhi’s and UP's top suppliers is guaranteed to give you a result where attention to detail is paramount. Similarly our Professional relationships with all third party contractors, consultants and government officials mean no stone is left unturned.
                        </li>
                      </ul>
                    </p>
                  </div>
                  <div className="iconlist-timeline" />
                </li>
              </ul>
            </div>
            <div className="col-md-4">
              <ul className="i-list medium">
                <li className="i-list-item">
                  <div className="icon">
                    <i className="fa fa-codepen" />
                  </div>
                  <div className="icon-content">
                    <h3 className="title">Control of Cost </h3>
                  </div>
                  <div className="icon-content">
                    <p>
                      <ul className="bold">
                        <li>Our policy for openness and transparency means that we offer a fully itemized breakdown of the cost of the entire project. A quotation is agreed and signed before the start of the project. As we are not fixed to any specific contractor, we are free to source only the best companies who meet our exacting standards and at a realistic Price. </li>
                      </ul>
                    </p>
                  </div>
                  <div className="iconlist-timeline" />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>




    </>
  );
};

export default WorkingArea;
